import React from "react";
import UserDashboardRow from "./UserDashboardRow";

class UserDashboardDisplay extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (
      !this.props.dashboard ||
      (this.props.dashboard &&
        this.props.dashboard.rows &&
        this.props.dashboard.rows.length <= 0)
    ) {
      var hour = new Date().getHours();
      var day_night = "day";
      var user = $(".signed-in-as strong").html();

      if (hour > 4 && hour < 20) {
        day_night = "day";
      } else {
        day_night = "night";
      }

      return (
        <div className="welcome-no-dashboards">
          <h1 className="text-center">
            {I18n.t("hello")} {user}!
          </h1>
          <div
            className="welcome-day"
            style={{ display: day_night == "day" ? "block" : "none" }}
          ></div>
          <div
            className="welcome-night"
            style={{ display: day_night == "night" ? "block" : "none" }}
          ></div>
        </div>
      );
    } else {
      var rows = this.props.dashboard.rows.map(function (row) {
        return (
          <UserDashboardRow
            key={row.id}
            {...row}
            widgets={self.props.widgets}
            date={self.props.date}
            home_show={self.props.home_show}
            daily_rentals={self.props.daily_rentals}
          />
        );
      });

      return <div className="UserDashboardDisplay">{rows}</div>;
    }
  }
}

export default UserDashboardDisplay;
